import axios, { AxiosError } from "axios"
import {
  requestInterceptorErrorSecurityCredentials,
  requestInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials,
  responseInterceptorSuccessCredentials,
} from "interceptors"
import { IPurchaseOrderProcessedFilters } from "types"
import {
  AND_PARAM,
  APPROVE_PATH,
  ASSIGN_PATH,
  CONDITIONS_PARAM,
  CREATE_PATH,
  OFFSET_PARAM,
  PAGE_SIZE_PARAM,
  PURCHASE_ORDER_PATH,
  RECEIVER_RUC_PARAM,
  REJECT_PATH,
  REPORT_PATH,
  SEARCH_PARAM,
  SIMPLIFIED_PATH,
  STATUS_PATH,
  USER_ID_PARAM_END,
} from "../../constants/paths"

const instance = axios.create({
  baseURL: process.env.REACT_APP_DOCUMENTS_API_SERVICE_DOMAIN,
})

instance.interceptors.request.use(
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials
)

instance.interceptors.response.use(
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials
)

export const getPurchaseOrdersService = async (
  filters: IPurchaseOrderProcessedFilters,
  pageSize: number,
  offset: number,
  userId: number
) => {
  try {
    const result = await instance.get(
      PURCHASE_ORDER_PATH +
        SEARCH_PARAM +
        CONDITIONS_PARAM +
        filters.conditions +
        AND_PARAM +
        PAGE_SIZE_PARAM +
        pageSize +
        AND_PARAM +
        OFFSET_PARAM +
        offset +
        AND_PARAM +
        USER_ID_PARAM_END +
        userId
    )
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const savePurchaseOrderService = async (
  purchaseOrder: any,
  userId: any
) => {
  try {
    const result = await instance.post(PURCHASE_ORDER_PATH, {
      ...purchaseOrder,
      userId,
    })
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const createPurchaseOrderService = async (
  id: number,
  purchaseOrder: any,
  userId: any
) => {
  try {
    const result = await instance.post(
      PURCHASE_ORDER_PATH + CREATE_PATH + `/${id}`,
      { ...purchaseOrder, userId }
    )
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const deletePurchaseOrderService = async (id: number) => {
  try {
    const result = await instance.delete(PURCHASE_ORDER_PATH + `/${id}`)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const approvePurchaseOrderService = async (
  id: number,
  purchaseOrder: any,
  userId: any
) => {
  try {
    const result = await instance.put(
      PURCHASE_ORDER_PATH + APPROVE_PATH + `/${id}`,
      { ...purchaseOrder, userId }
    )
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const assignPurchaseOrderService = async (
  id: number,
  userId: any,
  invoiceId: any
) => {
  try {
    const result = await instance.put(
      PURCHASE_ORDER_PATH + ASSIGN_PATH + `/${id}/${userId}/${invoiceId}`
    )
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const rejectPurchaseOrderService = async (
  id: number,
  purchaseOrder: any,
  userId: any
) => {
  try {
    const result = await instance.put(
      PURCHASE_ORDER_PATH + REJECT_PATH + `/${id}`,
      { ...purchaseOrder, userId }
    )
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const updatePurchaseOrderService = async (
  id: number,
  purchaseOrder: any,
  userId: any
) => {
  try {
    const result = await instance.put(PURCHASE_ORDER_PATH + `/${id}`, {
      ...purchaseOrder,
      userId,
    })
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const getPurchaseOrderByIdService = async (id: any) => {
  try {
    const result = await instance.get(PURCHASE_ORDER_PATH + "/" + id)
    return result.data
  } catch (error: any) {
    
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const wsChangeCoupaStatus = async (id: any, user: any) => {
  try {
    const result = await instance.get("/endcoupa?id=" + id + "&user=" + user)
    return result.data
  } catch (error: any) {
    
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const downloadPurchaseOrderReport = async () => {
  try {
    const result = await instance.get(PURCHASE_ORDER_PATH + REPORT_PATH, {
      responseType: "blob",
    })
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const updatePurchaseOrderStatusService = async (
  documentId: any,
  statusId: any,
  userId: any
) => {
  try {
    const result = await instance.post(PURCHASE_ORDER_PATH + STATUS_PATH, {
      documentId,
      statusId,
      userId,
    })
    return result.data
  } catch (error: any) {
    
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const getSimplifiedPurchaseOrdersServiceByFilters = async (
  conditions: string[],
  receiverRuc: any
) => {
  try {
    const result = await instance.get(
      PURCHASE_ORDER_PATH +
        SIMPLIFIED_PATH +
        SEARCH_PARAM +
        CONDITIONS_PARAM +
        conditions.join(",") +
        AND_PARAM +
        RECEIVER_RUC_PARAM +
        receiverRuc
    )
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}
